"use client";

import React, { useEffect, useState } from "react";
import { usePathname } from "next/navigation";

export function SitePreloader() {
  const pathname = usePathname();
  const [loaded, setLoaded] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const autoDismiss = () => {
      setLoaded(true);
      setTimeout(() => {
        setHidden(true);
      }, 220);
    };
    const timer = setTimeout(autoDismiss, 300);

    return () => clearTimeout(timer);
  }, []);

  if (pathname.startsWith("/admin") || pathname === "/login" || hidden) return null;

  return (
    <div
      id="site-preloader"
      className={`site-preloader ${loaded ? "is-loaded" : ""}`}
      aria-hidden="true"
    >
      <div className="preloader-content">
        <img
          src="/assets/logos/shaaira-biocare-logo-icon.svg"
          alt=""
          className="preloader-logo-img"
          width={56}
          height={56}
        />
        <div className="preloader-text">
          <span className="preloader-brand">
            <strong>Shaaira</strong> <strong>Biocare</strong>
          </span>
          <span className="preloader-tagline">Private-Label Formulation &amp; Manufacturing</span>
        </div>
      </div>
    </div>
  );
}
